import { safeText } from "@utils/utils";
import { Badge } from "@common";

function toneForStatus(status) {
  const key = safeText(status).toLowerCase();
  if (key === "active") {
    return {
      dot: "bg-palette-emerald-label",
      pill: "bg-palette-emerald-muted text-smiles-green",
    };
  }
  if (key === "inactive") {
    return {
      dot: "bg-palette-gray-placeholder",
      pill: "bg-palette-slate-muted text-smiles-gray",
    };
  }
  // Tracking-cash workflow statuses.
  if (key === "pending") {
    return {
      dot: "bg-palette-amber-label",
      pill: "bg-palette-amber-muted text-palette-amber-text",
    };
  }
  if (key === "confirm" || key === "confirmed") {
    return {
      dot: "bg-palette-emerald-label",
      pill: "bg-palette-emerald-muted text-palette-emerald-text",
    };
  }
  if (key === "reject" || key === "rejected") {
    return {
      dot: "bg-palette-rose-hover",
      pill: "bg-palette-rose-muted text-palette-rose-text",
    };
  }
  return {
    dot: "bg-palette-gray-placeholder",
    pill: "bg-palette-red-muted text-palette-red-heading",
  };
}

export default function StatusBadge({ status, variant = "pill" }) {
  const label = safeText(status) || "—";
  const tone = toneForStatus(label);

  if (variant === "dot") {
    return (
      <div className="flex items-center gap-2 text-sm text-palette-gray-secondary">
        <span className={`inline-block h-2 w-2 rounded-full ${tone.dot}`} />
        <span>{label}</span>
      </div>
    );
  }

  return <Badge className={tone.pill}>{label}</Badge>;
}
